import React from "react";
var __jsx = React.createElement;
import { twMerge } from "tailwind-merge";
import { useTranslation } from "@i18n";
import { trackEvents } from "@/common/events/events";
import useFilterPage from "@/pages/search/searchHooks/useSearchAndFilters";
import { useMemo } from "react";
var SearchUspItem = function SearchUspItem(_ref) {
  var title = _ref.title,
    description = _ref.description,
    src = _ref.src,
    onLearnMoreClick = _ref.onLearnMoreClick,
    pattern = _ref.pattern,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "default" : _ref$variant,
    id = _ref.id;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFilterPage = useFilterPage(),
    isAutosPage = _useFilterPage.isAutosPage,
    isYearsPage = _useFilterPage.isYearsPage,
    isDealPage = _useFilterPage.isDealPage;
  var locationName = useMemo(function () {
    if (isAutosPage) return "autos";
    if (isYearsPage) return "years";
    if (isDealPage) return "deals";else return "filters";
  }, [isAutosPage, isYearsPage, isDealPage]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: twMerge("rounded-xl py-6 px-4 flex flex-col gap-3 w-full items-center relative overflow-hidden", variant == "default" ? "bg-[linear-gradient(207deg,_#3C56D4_15.08%,_#6076E2_135.66%)]" : "bg-[linear-gradient(207deg,_#049D58_15.08%,_#21C57B_135.66%)]")
  }, pattern && pattern == "wave" && /*#__PURE__*/React.createElement("div", {
    className: "w-full h-full absolute top-0 left-0 "
  }, /*#__PURE__*/React.createElement("img", {
    className: "w-full h-full lg:transform lg:scale-x-110 object-cover opacity-30 transform scale-125",
    src: "/assets/images/usps/wave.svg",
    alt: ""
  })), pattern && pattern == "circle" && /*#__PURE__*/React.createElement("div", {
    className: twMerge("absolute top-[-100px] left-[-100px] lg:top-[-100px] lg:left-[-100px] w-[214px] h-[214px] rounded-full border-[50px] border-solid", variant == "default" && "border-[#5a71dc]", variant == "green" && "border-[#28b173]")
  }), /*#__PURE__*/React.createElement("div", {
    className: "z-[2]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-full mb-2"
  }, /*#__PURE__*/React.createElement("img", {
    className: "w-14 h-14",
    src: src,
    alt: title,
    loading: "lazy"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2 items-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-white font-bold text-center text-[20px] leading-8"
  }, title), description && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "text-white font-medium text-xs text-center leading-4 lg:max-w-[320px] lg:text-sm"
  }, description))), /*#__PURE__*/React.createElement("p", {
    onClick: function onClick() {
      trackEvents("usp_cta_clicked", {
        referral_location: locationName,
        usp_number: id
      });
      onLearnMoreClick();
    },
    className: "text-xs font-medium text-center underline text-white cursor-pointer mt-4"
  }, t("اعرف أكثر", {
    ns: "web_home"
  })))));
};
export default SearchUspItem;